import i18n
	from '../i18n/i18n'

export default class full {
	constructor() {
		this.language = i18n.language.substr(0, 2)
		this.characters = [];
		const languages = {
			de: require('../data/de/characters.json'),
			en: require('../data/en/characters.json')
		};
		this.characters = languages[this.language]
	}

	getCategories() {
		let categories = this.characters.systems.short.categories;
		delete categories.unknown;
		return categories;
	}

	getKuerzungenByCategory(category) {
		var result = {};
		var count = 0;
		for (let key in this.characters.systems.short.categories) {
			if (category !== '0') {
				if (key === category.toString()) {
					let kuerzungen = this.characters.systems.short.categories[key];
					for (let key2 in kuerzungen.content) {
						var kuerzung = kuerzungen.content[key2];
						kuerzung.accessibilityString = kuerzung.title;
						if (key === "short1" && kuerzung.title.length === 2) {
							kuerzung.accessibilityString = kuerzung.accessibilityString
								.split("")
								.join(" ");
						}
						if (!kuerzung.hasOwnProperty("dots")) {
							kuerzung.dots = [];
							kuerzung.title = "!!! Missing Character !!! (index: " + key + ")";
						}
						result[key2] = kuerzung;
					}
				}
			} else {
				let kuerzungen = this.characters.systems.short.categories[key];
				for (let key2 in kuerzungen.content) {
					var kuerzung = kuerzungen.content[key2];
					kuerzung.accessibilityString = kuerzung.title;
					if (key === "short1" && kuerzung.title.length === 2) {
						kuerzung.accessibilityString = kuerzung.accessibilityString
							.split("")
							.join(" ");
					}
					kuerzung.category = kuerzungen.singular
					if (!kuerzung.hasOwnProperty("dots")) {
						kuerzung.dots = [];
						kuerzung.title = "!!! Missing Character !!! (index: " + key + ")";
					}
					result[count] = kuerzung;
					count += 1;
				}
			}
		}
		result = this.sort(result);
		return result;
	}

	getAllKuerzungen() {
		var result = {};
		for (let key in this.characters.systems.short.categories) {
			let kuerzungen = this.characters.systems.short.categories[key];
			for (let key2 in kuerzungen.content) {
				var kuerzung = kuerzungen.content[key2];
				kuerzung.category = key;
				kuerzung.categorySingular = kuerzungen.singular;
				kuerzung.accessibilityString = kuerzung.title;
				if (key === "short1" && kuerzung.title.length === 2) {
					kuerzung.accessibilityString = kuerzung.accessibilityString
						.split("")
						.join(" ");
				}
				if (!kuerzung.hasOwnProperty("dots")) {
					kuerzung.dots = [];
					kuerzung.title = "!!! Missing Character !!! (index: " + key + ")";
				}
				result[key2] = kuerzung;
			}
		}
		result = this.sort(result);
		return result;
	}

	sort = (list) => {
		var sorted = {};
		var values = Object.values(list);

		//sort values by title
		var sortedValues = values.sort((a, b) => {
			var titleA = a.title.toLowerCase(),
				titleB = b.title.toLowerCase();
			if (titleA < titleB) return -1;
			if (titleA > titleB) return 1;
			return 0;
		});
		//map sorted array to keys
		Object.keys(list).map((key, i) => {
			sorted[key] = sortedValues[i];
			return sorted[key];
		});
		return sorted;
	}
};